/**
 * @ngdoc config
 * @name routeProviderConfig
 * @description
 * Sets the routes for the Campaigns section:
 * - The default one (`/`).
 *
 * @param {Service} $routeProvider The interface for the Angular router.
 * @memberof campaigns
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/campaigns', {
    template: '<campaigns></campaigns>',
  })
  .when('/campaign/:id?', {
    template: ({ id = '' }) => `<campaign campaign-id="${id}"></campaign>`,
  })
  .otherwise({ redirectTo: '/campaigns' });
};

export default routeProviderConfig;



// WEBPACK FOOTER //
// ./src/frontend/modules/campaigns/configs/routeProvider.config.js